"use client"

import { API_PERMISSIONS_PATH, API_PREFIX_ROLES_PATH } from "@/constants/prefix-path-api"
import { message } from "antd"
import { AxiosRequestConfig } from "axios"
import { useState } from "react"
import { AdminHttpClient } from "../../../../app/api/AdminHttpClient"
import { t } from "../../../../languages/i18n"



const roleService = () => {
  const [isLoading, setIsLoading] = useState(false)

  const getAllPermissions = async () => {
    setIsLoading(true)
    try {
      const response = await AdminHttpClient.get(API_PERMISSIONS_PATH)
      return response?.permissions || response
    } catch (error) {
      message.error(t("Lỗi khi tải danh sách tất cả quyền."))
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const getRoleById = async (id: number | string) => {
    setIsLoading(true)

    if (!id) {
      message.error(t("Id không hợp lệ."))
      setIsLoading(false)
      return null
    }

    const params: AxiosRequestConfig["params"] = {
      populate: "*",
    }

    try {
      const response = await AdminHttpClient.get(`${API_PREFIX_ROLES_PATH}/${id}`, { params })

      return response?.role || response
    } catch (error) {
      message.error(t("Lỗi khi tải dữ liệu vai trò. Vui lòng thử lại."))
      console.error("GET_ROLE_BY_ID_ERROR:", error)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const createRole = async (payload: any) => {
    setIsLoading(true)
    try {
      const response = await AdminHttpClient.post(API_PREFIX_ROLES_PATH, payload)

      message.success(t("Tạo vai trò thành công!"))
      return response
    } catch (error: any) {
      const errorMsg = error.response?.data?.error?.message || t("Lỗi khi tạo vai trò.")
      message.error(errorMsg)
      console.error("CREATE_ROLE_ERROR:", error)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  /**
   * CẬP NHẬT ROLE VÀ PERMISSIONS
   * @param id: ID của role cần update
   * @param payload: Theo format trong ảnh: { name, description, permissions: { ... } }
   */
  const updateRole = async (id: number | string, payload: any) => {
    setIsLoading(true)

    if (!id) {
      message.error(t("Thiếu id vai trò để cập nhật."))
      setIsLoading(false)
      return null
    }

    try {
      const response = await AdminHttpClient.put(`${API_PREFIX_ROLES_PATH}/${id}`, payload)

      message.success(t("Cập nhật vai trò thành công!"))
      return response
    } catch (error) {
      message.error(t("Lỗi khi cập nhật vai trò. Vui lòng thử lại."))
      console.error("UPDATE_ROLE_ERROR:", error)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const deleteRole = async (id: number | string) => {
    setIsLoading(true)
    try {
      await AdminHttpClient.delete(`${API_PREFIX_ROLES_PATH}/${id}`)

      message.success(t("Xóa vai trò thành công!"))
      return true
    } catch (error: any) {
      const errorMsg = error.response?.data?.error?.message || t("Lỗi khi xóa vai trò.")
      message.error(errorMsg)
      console.error("DELETE_ROLE_ERROR:", error)
      return false
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    getRoleById,
    createRole,
    updateRole,
    deleteRole,
    getAllPermissions,
  }
}

export default roleService
